import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Icon from "./Icon";
import theme from "../styles/theme";
import { StyledText, TextSize } from "./Text";

type Props = {
  name: string;
  to: any;
  margin: number;
  icon: string;
  customStyle?: Object;
  children?: any;
  isMain?: boolean;
  fontSize: string;
  click?: any;
  isDropDown?: boolean;
  isSignOut?: boolean;
  isOpen: boolean;
};
const SideStyled = styled(StyledText)`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  line-height: 25px;
`;

const ActiveStyled = styled.div`
  width: 100%;
  &:hover {
    background-color: inherit;
    border-radius: ${({ theme }) => theme.radius};
  }
`;

function SidebarMenuItem({
  name,
  to,
  margin,
  icon,
  children = null,
  fontSize,
  isMain = false,
  click,
  isDropDown = false,
  isSignOut,
  isOpen,
}: Props): JSX.Element {
  let style = {
    textDecoration: "none",
    padding: "12px 24px",
    alignContent: "center",
    textoverflow: "clip",
    display: "flex",
    color: "#FFFFFF",
    borderRadius: "4px",
    margin: "4px 0px",
  };
  let activeStyle = {
    textDecoration: "none",
    padding: "12px 24px",
    alignContent: "center",
    textoverflow: "clip",
    display: "flex",
    color: "#FFFFFF",
    background: "linear-gradient(90deg, #B03434 0%, #184B68 118.29%)",
    boxShadow: "0px 6px 35px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
    margin: "4px 0px",
  };
  const appendStyle = { justifyContent: "space-between", whiteSpace: "nowrap" };

  if (isDropDown) {
    style = { ...style, ...appendStyle };
  }
  if (isOpen) {
    style = { ...style, padding: "10px 15px" };
    activeStyle = { ...activeStyle, padding: "10px 15px" };
  } else {
    style = { ...style, padding: "8px 12px" };
    activeStyle = { ...activeStyle, padding: "8px 12px" };
  }
  return (
    <ActiveStyled
      onClick={click}
      style={{
        userSelect: "none", // Prevent text selection
      }}
    >
      <NavLink
        to={to}
        style={({ isActive }) => (isActive ? activeStyle : style)}
      >
        <SideStyled textSize={TextSize.sidebar}>
          <Icon mr={margin} name={icon} />
        </SideStyled>
        {isOpen && <SideStyled textSize={TextSize.sidebar}>{name}</SideStyled>}
        {children}
      </NavLink>
    </ActiveStyled>
  );
}

export default React.memo(SidebarMenuItem);
